import { useEffect, useState } from 'react';

export default function UserAvatar({
  user,
  fallback,
  className = '',
  imageClassName = '',
  children,
}) {
  const avatarUrl = typeof user?.avatar_url === 'string' ? user.avatar_url.trim() : '';
  const [imageFailed, setImageFailed] = useState(false);
  const initial = fallback || user?.username?.trim()?.[0]?.toUpperCase() || '影';

  useEffect(() => {
    setImageFailed(false);
  }, [avatarUrl]);

  return (
    <span className={className} aria-label={user?.username ? `${user.username}的头像` : '用户头像'}>
      {avatarUrl && !imageFailed ? (
        <img
          src={avatarUrl}
          alt=""
          referrerPolicy="no-referrer"
          className={`block h-full w-full object-cover ${imageClassName}`}
          style={{ borderRadius: 'inherit' }}
          onError={() => setImageFailed(true)}
        />
      ) : (
        <span aria-hidden="true">{initial}</span>
      )}
      {children}
    </span>
  );
}
